// extracted by mini-css-extract-plugin
module.exports = {"bar":"UserBar_bar__xT8Ci","link":"UserBar_link__1wk1a","avatar":"UserBar_avatar__3kDJT","notify":"UserBar_notify__PQSFY","info":"UserBar_info__1f2jb","item":"UserBar_item__11fLN"};